"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
function HeaderNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <>
      <div className="flex-1 flex justify-end md:hidden">
        <Button variant="ghost" size="icon" className="hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
          {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </Button>
      </div>

      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.label === "Goodies et sacs" ? "https://cadeaux-daffaires-entreprise.myshopify.com" : item.href || "#"} className="hover:!bg-transparent focus:!bg-transparent relative px-4 py-2 text-sm font-medium text-foreground transition-all duration-[var(--duration-fast)] after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-accent-light after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {mobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background border-b shadow-medium md:hidden">
          <nav className="container mx-auto px-4 py-4">
            <ul className="flex flex-col gap-2">
              {menuItems.map((item, i) => <li key={item.id} data-index={i}>
                  <Link to={item.label === "Goodies et sacs" ? "https://cadeaux-daffaires-entreprise.myshopify.com" : item.href || "#"} className="block px-4 py-2 text-sm font-medium text-foreground hover:bg-muted rounded-md transition-colors" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function EnTete() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="entête" className={`sticky top-0 z-50 w-full bg-background transition-all duration-[var(--duration-medium)] ${scrolled ? "h-14 shadow-medium" : "h-20"}`}>
      <div className="container mx-auto h-full px-4">
        <div className="flex h-full items-center justify-center md:justify-between gap-4">
          <Link to="/" className="shrink-0" aria-label="LOCAL-COM">
            <img src="https://pet-loon.10web.cloud/wp-content/uploads/2026/02/ChatGPT-Image-Nov-16-2025-01_36_29-PM.png" alt="LOCAL-COM" className="h-12" />
          </Link>

          <MenuProvider menu_id="3" className="flex items-center flex-1">
            <HeaderNavigation />
          </MenuProvider>

          <Button asChild className="inline-flex mx-auto md:mx-0 shadow-medium hover:scale-[1.02] active:scale-100 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
            <Link to="https://calendly.com/poirecommunication/30min">Contactez-nous</Link>
          </Button>
        </div>
      </div>
    </header>;
}